import {GlobalDeploymentSettings, DeploymentPdfConfig} from '@stores'

/**
 * Can be changed in a deployment config (at runtime)
 */
export const DEFAULT_DEPLOYMENT_SETTINGS: GlobalDeploymentSettings = {
  es: {
    maxBatchQueue: 5
  },
  socketIO: true,
  pdf: {
    target: DEBUG ? 'server' : 'client',
  },
  detailPaneTabDropdownNav: false,
  hideHeaderAfterScrollDelay: false,
  services: {nest: true},
  maxImagesPerUpload: 5,
  viewOptions: {allowAllButton: false},

  /**
   * Anything less than this should count as double click
   */
  doubleClickMs: 400,
  groupByHeroCards: false,
  sync: {
    pollInterval: 5000
  },
  c8: {
    sso: true
  },
  assortments: {
    // TODO - need to implement virtual load on demand so these can go back to sane numbers
    itemsPerQuery: 10,
    maxSwatches: 1000
  },
  updateCardViewDebounce: 1000,
  flexLayout: {
    scrollIntoViewDelayAfterNewChildTab: 200,
    layoutPreviewMs: 250,
    throttleResizeMs: 250
  },
  reports: {
    defaultName: 'New Report',
    updateSettingsDebounce: 2000,
    hideToolbarsAfterScrollDelay: 5000,
    draftReports: false,
    clearJustLoadedReportTimeout: 5000
  },
  batch: {ms: 100, max: 5 },
  syncSnackbarLocation: {
    vertical: 'bottom',
    horizontal: 'left'
  },
  notificationPollInterval: 60000,
  publishedItemPollInterval: 5000,
  titleBarHeight: 47,
  defaults: {
    catalog: {
      cardsPerVirtualRow: 50,
      fieldBehavior: {
        all: false,
        filter: false,
        editable: false,
        group: false,
        sort: false
      },
      comments: true
    }
  },
  PRELOAD_HOVER_TIME: 300,
  AUTOHIDE_SNACKBAR_DURATION: 6000,
  HOVER_TIMEOUT: 400,
  cardPopover: {
    interactionKind: 'click',
    ms: 400,
    closeMs: 380,
    hideHoverButtonsMs: 2500
  },

  usingBulkAssignAPI: true,
  maxGroupDepth: 2,
  maxSubtitlesPerGroup: 3,
  defaultProductName: 'Centric Visual Innovation Platform',
  maxNestedItemsToShow: 10,
  updateIndicatorMs: 4000,
  showUserSettings: true,
  /**
   * When navigating to the next/prior catalog item we want to take enough time to actually animate the unload/load
   */
  modalSwitchItemDelayMs: 50,
  pivotView: false,
  sidebarWidth: {left: 256, right: 256},
  showNoValueAsEmpty: false,
  showWorkspaceTitleWithLibraries: true,
  // deleteInfo: {
  //   markAsDelete: false,
  // },
  showHeaderSyncIndicator: true,
  showC8ButtonInTopBar: true,
  maxChildGroupColumns: 5,
  allowGridChanges: true,
  maxCatalogItemOrderByTerms: 2,
  dragDropImageWidth: 300,
  numberOfPDFVisibleViewOptions: 6,
  showSortedVersions: false,
  sortDefaultAttributes: true,
  hierarchyDebounceMs: 3000,
  inlineCardFieldEditing: true,
  showUnsavedPerspectiveMenu: false,
  hideFilteredSearchResults: true,
  maxHitsForSpecGroupAssociatedItems: 5,
  //usingBulkAssignAPI: true,

  filter: {
    maxValuesToLoadPerGroup: 15,
    debounceLocalSearchMs: 100,
    debounceSearchEsMs: 200,
    debounceRefetchFiltersEs: 500
  }
}

export const defaultPDFConfig: DeploymentPdfConfig = {
  templates: [],
  pdfDownloadName: 'Centric',
  defaultTemplate: {
    imageSize: 'smallImage',
    imageRatio: 'square',
    columns: 'standard',
    selectedSection: 'document',
    watermark: false,
    queryLimit: 50,
    group: {
      spec: {
        style: {
          backgroundColor: '#fefbe2',
          border: '1px solid #dcd6d6'
        }
      }
    },
    customAttributes: {},
    groupByCustomAttributes: {},
    selectedTemplate: 'vlp',
    layout: 'row',
    productPage: {
      fontFamily: {
        currentDate: 'Roboto Regular',
        filterFooter: 'Roboto Regular',
        lineItemText: 'Roboto Regular',
        filterText: 'Roboto Regular',
        attributeText: 'Roboto Bold',
        headerHierarchy: 'Roboto Regular'
      }
    },
    document: [
      {
        size: 'A4',
        pageHeight: 515,
        author: '',
        title: '',
        subtitle: '',
        subject: '',
        orientation: 'landscape',
        brand: 'Centric Software'
      },
      {
        size: 'A3',
        pageHeight: 763,
        author: '',
        title: '',
        subtitle: '',
        subject: '',
        orientation: 'landscape',
        brand: 'Centric Software'
      }
    ],
    showLogo: true,
    // showLabel: true,
    showTotalCount: true,
    showFilters: true,
    showCount: true,
    showHrGroupingLines: true,
    showVtGroupingLines: true,
    sections: {
      cover: false,
      products: true
    },
    header: {
      show: true,
      //image: './images/Asics_Logo.svg-2.png',
      showGroupBy: false
    },
    footer: {
      show: true,
      showPage: true
    }
  },
  fieldCount: 8,
  fonts: [
    {
      name: 'Asics Bold',
      path: '/static/fonts/ASICS-Bold.ttf'
    }, {
      name: 'Asics Light',
      path: '/static/fonts/ASICS-Light.ttf'
    }, {
      name: 'Asics Regular',
      path: '/static/fonts/ASICS-Regular.ttf'
    }, {
      name: 'Roboto Regular',
      path: '/static/fonts/roboto-regular-webfont.ttf'
    }, {
      name: 'Roboto Bold',
      path: '/static/fonts/roboto-bold-webfont.ttf'
    }, {
      name: 'Arial',
      path: '/static/fonts/arial.ttf'
    }, {
      name: 'Arial Bold',
      path: '/static/fonts/Arial Bold.ttf'
    }
  ],
  versions: ['collectionVersion.name'],
  types: ['collectionVersion.name', 'merchProduct.name', 'collection.name']
}

export const REACT_DATAGRID_LICENSE_KEY: string = 'AppName=multi_app,Company=CentricSoftware,ExpiryDate=2022-11-11,LicenseDeveloperCount=2,LicenseType=multi_app,Ref=CentricSoftwareLicenseRef,Z=1207408073-2416202778106351944815218512074080731506142083'


// WEBPACK FOOTER //
// ./src/stores/ui/System Default Settings.ts